<template>
	<div>
		<div>
			<formcontrol
				name="query"
				v-model="term"
				placeholder="Поиск по сайту"
				:autofocus="true"
				@update:modelValue="search"
			></formcontrol>

			<div v-if="term && (loading || results || notFound)" class="mt-8">
				<div class="text-2xl font-black mb-6">
					Результаты поиска:
				</div>

				<div class="my-6 bottom-tabs px-0">
					<a href="#" v-for="type in Object.keys(types)"
					   @click.prevent="changeType(type, true)"
					   class="cursor-pointer"
					   :class="{ 'active': selectedType === type}"
					>
						{{ types[type] }}
					</a>
				</div>

				<div v-if="selectedType === 'post'">
					<div v-if="channels.length" class="relative text-sm my-4">
						<div class="flex items-center gap-2">
							<div @click="toggleChannelsDropdown"
								 class="p-1.5 px-2 rounded bg-gray-500/10 cursor-pointer">
								<div v-if="selectedChannel">
									<div>{{ selectedChannel.name }}</div>
								</div>
								<div v-else class="text-gray-500">
									Все подсайты
								</div>
							</div>
							<svg-icon v-if="selectedChannel"
									  @click.prevent="selectChannel(null)"
									  icon="x-lg"
									  class="text-red-500 shrink-0 w-4 h-4 cursor-pointer"/>
						</div>
						<div v-if="channelDropdownOpen"
							 v-click-outside="closeChannelsDropdown"
							 class="absolute top-full space-y-0.5 translate-y-2 shadow-lg left-0 w-auto max-h-56 overflow-scroll max-w-80 p-2 rounded bg-white dark:bg-slate-700 border border-gray-200 dark:border-slate-400"
						>
							<div @click="selectChannel(channel)" v-for="channel in channels"
								 class="p-1.5 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-500/10">
								<div class="w-5 h-5 shrink-0 rounded bg-center bg-cover border border-gray-500/20"
									 :style="'background-image: url('+ channel.ava +')'"></div>
								<div>{{ channel.name }}</div>
							</div>
						</div>
					</div>
				</div>

				<div v-if="loading" class="p-2 text-gray-500 text-center">
					<div class="inline-flex space-x-2 mx-auto">
						<div class="w-2 h-2 rounded-full animate-pulse bg-gray-500"></div>
						<div class="w-2 h-2 rounded-full animate-pulse bg-gray-500"></div>
						<div class="w-2 h-2 rounded-full animate-pulse bg-gray-500"></div>
					</div>
				</div>
				<div v-else-if="notFound" class="p-2 text-gray-500">
					Ничего не нашлось
				</div>
				<div v-else class="text-base">

					<div class="space-y-2 ">
						<a target="_blank" :href="result.url" v-for="(result, index) in results" :key="index"
						   class="rounded flex items-center leading-tight space-x-2 p-2 text-gray hover:bg-gray-100 dark:hover:bg-slate-600">
							<div class="w-6 text-right text-gray-500">
								{{ getResultIndex(index) }}.
							</div>
							<div>
								<svg-icon v-if="result.type === 'comment'" icon="chat-fill"
										  class="w-4 h-4 shrink-0 mt-0.5"></svg-icon>
								<svg-icon v-if="result.type === 'post'" icon="file-earmark-post"
										  class="w-4 h-4 shrink-0 mt-0.5"></svg-icon>
								<svg-icon v-if="result.type === 'user'" icon="person-fill"
										  class="w-4 h-4 shrink-0 mt-0.5"></svg-icon>
								<svg-icon v-if="result.type === 'channel'" icon="list-ul"
										  class="w-4 h-4 shrink-0 mt-0.5"></svg-icon>
								<svg-icon v-if="result.type === 'tag'" icon="hash"
										  class="w-4 h-4 shrink-0"></svg-icon>
							</div>
							<img v-if="result.img" :src="result.img"
								 class="w-4 h-4shrink-0 rounded overflow-hidden object-cover">

							<div class="text-black dark:text-white truncate" v-html="result.label"></div>
						</a>
					</div>

					<div class="text-center">
						<pagination
							class="w-auto inline-flex mt-6 mx-auto"
							:current-page="page"
							:per-page="perPage"
							:total-pages="totalPages"
							@pageChanged="changePage"
						></pagination>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import Pagination from "../components/Pagination.vue";
import Urls from "../../js/modules/Urls";

let delay = 500;
let timeout;

export default {
	components: {Pagination},
	props: [
		'types',
	],
	data() {
		return {
			selectedType: this.getType(),
			term: this.getTerm(),
			results: [],
			loading: false,
			notFound: false,
			page: 1,
			perPage: 20,
			totalPages: 1,
			channels: [],
			channelDropdownOpen: false,
			selectedChannel: null,
		};
	},
	mounted() {
		this.loadChannels();

		if (this.term) {
			this.search(this.term);
		}

		window.addEventListener("popstate", (event) => {
			this.term = event?.state?.term || '';
			this.changeType(event?.state?.type || '');
		});
	},
	methods: {
		getQueryParams() {
			return new URLSearchParams(window.location.search);
		},
		getTerm() {
			return this.getQueryParams().get('query') || '';
		},
		getType() {
			return this.getQueryParams().get('type') || '';
		},
		loadChannels() {
			Client.get('/api/v1.1/channel/list/compact?conditions[]=visibleOnly')
				.then(response => {
					this.channels = response.data.data;
				})
				.then(error => {
					console.log(error);
				})
		},
		closeChannelsDropdown() {
			this.channelDropdownOpen = false;
		},
		toggleChannelsDropdown() {
			this.channelDropdownOpen = !this.channelDropdownOpen;
		},
		selectChannel(channel) {
			this.selectedChannel = channel;
			this.closeChannelsDropdown();

			this.page = 1;
			this.search(this.term);
		},
		setTerm(term) {
			let url = Urls.setQueryParamToUrl(Urls.getCurrentUrl(), 'query', term);
			window.history.replaceState({type: this.selectedType, term: this.term}, '', url);
		},
		changeType(type, setState = false) {
			this.selectedType = type;
			this.page = 1;

			if (setState) {
				let url = Urls.setQueryParamToUrl(Urls.getCurrentUrl(), 'type', type);
				window.history.pushState({type: this.selectedType, term: this.term}, '', url);
			}

			this.search(this.term);
		},
		changePage(page) {
			this.loading = true;
			this.page = Number(page);
			this.search(this.term);
		},
		getResultIndex(index) {
			return index + 1 + ((this.page - 1) * this.perPage);
		},
		search(value) {
			this.term = value;

			if (timeout) {
				clearTimeout(timeout);
			}

			if (this.term.trim().length > 0) {
				this.setTerm(this.term);
				timeout = setTimeout(() => {
					this.loading = true;
					Client.post('/api/v1.1/search', {
						query: this.term,
						page: this.page,
						perPage: this.perPage,
						type: this.selectedType,
						channel_id: this.selectedType === 'post' && this.selectedChannel ? this.selectedChannel.id : null,
					}).then(response => {
						this.loading = false;
						this.results = response.data.data;
						this.notFound = !this.results.length;
						this.totalPages = response.data.meta.totalPages;
					}).catch(error => {
						notify({
							type: 'error',
							text: 'Поиску совсем плохо. Звони фиксикам'
						});
						this.loading = false;
					})
				}, delay);
			}
		}
	},
}
</script>
